/* ALL THINGS BIG customer interaction repairs. No orders, inventory writes, or tracking. */
(() => {
  'use strict';
  if (window.__bbbCustomerRepairs) return;
  window.__bbbCustomerRepairs = true;
  function config() {
    try { return JSON.parse(document.getElementById('bbb-customer-config')?.textContent || '{}'); }
    catch (_) { return {}; }
  }
  function sameStoreUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /^https?:$/.test(url.protocol) ? url : null;
    } catch (_) { return null; }
  }
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch (_) { /* Optional UI preference only. */ } }
  };
  function cardKey(card) {
    return 'bbb:print:' + (card.querySelector('.bbwc-product-top h3')?.textContent.trim() || '');
  }
  function setDestination(anchor, url) {
    if (!anchor) return;
    if (url) {
      anchor.href = url.pathname + url.search + url.hash;
      anchor.removeAttribute('aria-disabled');
      anchor.removeAttribute('tabindex');
    } else {
      anchor.removeAttribute('href');
      anchor.setAttribute('aria-disabled', 'true');
      anchor.setAttribute('tabindex', '-1');
    }
  }
  function ensureShoppingLinks(card) {
    const image = card.querySelector('.bbwc-image-wrap');
    let imageLink = card.querySelector('.bbb-card-image-link');
    if (image && !imageLink) {
      imageLink = document.createElement('a');
      imageLink.className = 'bbb-card-image-link';
      image.parentNode.insertBefore(imageLink, image);
      imageLink.append(image);
    }
    const title = card.querySelector('.bbwc-product-top h3');
    let titleLink = title?.querySelector('.bbb-card-title-link');
    if (title && !titleLink) {
      titleLink = document.createElement('a');
      titleLink.className = 'bbb-card-title-link';
      while (title.firstChild) titleLink.append(title.firstChild);
      title.append(titleLink);
    }
    if (imageLink && title) imageLink.setAttribute('aria-label', title.textContent.trim());
    return [imageLink, titleLink];
  }
  function syncCard(card, button) {
    if (!button) return;
    const color = button.dataset.print;
    const panel = Array.from(card.querySelectorAll('[data-print-panel]')).find(node => node.dataset.printPanel === color);
    if (!panel) return;
    card.querySelectorAll('[data-print-panel]').forEach(node => { node.hidden = node !== panel; });
    card.querySelectorAll('button[data-print]').forEach(node => node.setAttribute('aria-pressed', String(node === button)));
    const label = card.querySelector('[data-print-label]');
    if (label) label.textContent = button.dataset.label || button.textContent.trim();
    const link = card.querySelector('[data-product-link]');
    const source = card.querySelector('[data-variant-links]');
    if (!link || !source) return; // A draft preview must never become purchasable here.
    let variants;
    try { variants = JSON.parse(source.textContent); } catch (_) { return; }
    if (!Array.isArray(variants)) return;
    const matches = variants.filter(variant => Array.isArray(variant.options) && variant.options.includes(button.dataset.label));
    const chosen = matches.find(variant => variant.available === true) || matches[0];
    const destination = sameStoreUrl(chosen?.url);
    const linkedMedia = ensureShoppingLinks(card);
    [link, ...linkedMedia].forEach(anchor => setDestination(anchor, destination));
    const labels = config();
    const caption = link.querySelector('[data-product-link-label]');
    if (caption) caption.textContent = destination ? link.dataset.defaultLabel : labels.unavailable;
    const stock = card.querySelector('[data-print-stock]');
    if (stock) {
      const message = !chosen ? labels.unavailable : matches.some(variant => variant.available === true) ? '' : labels.soldOut;
      stock.textContent = message || '';
      stock.hidden = !message;
    }
    const price = card.querySelector('.bbwc-product-top > span');
    const priced = matches.filter(variant => Number.isFinite(variant.price) && typeof variant.formatted_price === 'string');
    if (price && priced.length) {
      const minimum = priced.reduce((best, variant) => variant.price < best.price ? variant : best);
      const varies = priced.some(variant => variant.price !== minimum.price);
      price.textContent = varies ? (labels.priceFrom || '__BBB_PRICE__').replace('__BBB_PRICE__', minimum.formatted_price) : minimum.formatted_price;
    } else if (price && !chosen) {
      price.textContent = labels.unavailable || '';
    }
  }
  function initializeCards() {
    document.querySelectorAll('bbb-print-preview').forEach(card => {
      const buttons = Array.from(card.querySelectorAll('button[data-print]'));
      const saved = storage.get(cardKey(card));
      const selected = buttons.find(button => button.dataset.print === saved) || buttons.find(button => button.getAttribute('aria-pressed') === 'true') || buttons[0];
      syncCard(card, selected);
    });
  }
  // Runs after the existing card listener; synchronizes price, availability and every product link.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const disabled = event.target.closest('a[aria-disabled="true"]');
    if (disabled && disabled.closest('bbb-print-preview')) { event.preventDefault(); return; }
    const button = event.target.closest('bbb-print-preview button[data-print]');
    if (!button) return;
    const card = button.closest('bbb-print-preview');
    storage.set(cardKey(card), button.dataset.print);
    syncCard(card, button);
  });
  let cartVersion = 0;
  let pendingCart;
  const pendingMutations = new Set();
  function paintCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('.bbb-bag').forEach(bag => {
      const badge = bag.querySelector('.bbb-bag-number');
      if (badge && badge.textContent !== String(count)) badge.textContent = String(count);
      const name = bag.querySelector('span')?.textContent.trim() || '';
      bag.setAttribute('aria-label', `${name} (${count})`);
    });
  }
  function nextCartVersion() {
    pendingCart?.abort();
    return ++cartVersion;
  }
  async function refreshCart(version = nextCartVersion()) {
    const url = sameStoreUrl(config().cartUrl);
    if (!url || version !== cartVersion) return;
    const controller = new AbortController();
    pendingCart = controller;
    try {
      const response = await fetch(url.pathname + url.search, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
      if (!response.ok) return;
      const cart = await response.json();
      if (version === cartVersion) paintCount(cart.item_count);
    } catch (_) { /* Keep the last known count on network failure; never fabricate an empty bag. */ }
    finally { if (pendingCart === controller) pendingCart = undefined; }
  }
  function requestCartRefresh() {
    if (pendingMutations.size === 0) refreshCart();
  }
  document.addEventListener('shopify:cart:lines-update', event => {
    const version = nextCartVersion();
    if (!event.promise || typeof event.promise.then !== 'function') {
      requestCartRefresh();
      return;
    }
    const mutation = {};
    pendingMutations.add(mutation);
    Promise.resolve(event.promise).then(result => {
      if (version !== cartVersion) return;
      const count = result?.cart?.totalQuantity ?? result?.detail?.itemCount;
      if (Number.isInteger(count) && count >= 0) paintCount(count);
    }).catch(() => {
      // Retain the last confirmed count until the read-only reconciliation finishes.
    }).finally(() => {
      pendingMutations.delete(mutation);
      requestCartRefresh();
    });
  });
  function redirectLegacyLink() {
    const settings = config();
    const root = sameStoreUrl(settings.rootUrl);
    if (!root || location.pathname.replace(/\/$/, '') !== root.pathname.replace(/\/$/, '')) return;
    const target = sameStoreUrl(settings.legacyLinks?.[location.hash]);
    if (!target) return;
    const current = new URL(location.href);
    current.searchParams.forEach((value, key) => { if (!target.searchParams.has(key)) target.searchParams.append(key, value); });
    location.replace(target.pathname + target.search + target.hash);
  }
  function initialize() {
    redirectLegacyLink();
    initializeCards();
    const badge = document.querySelector('.bbb-bag-number');
    if (badge) paintCount(Number(badge.textContent));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:page:view', initializeCards);
  window.addEventListener('hashchange', redirectLegacyLink);
  window.addEventListener('pageshow', event => { initializeCards(); if (event.persisted) requestCartRefresh(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') requestCartRefresh(); });
})();
